module.exports = __webpack_public_path__ + "img/circle.d3a07084.svg";